const NullComponent: React.FC<any> = () => {
    return (null)
}

export default NullComponent